<template>
  <nav class="toggle-buttons">
    <button
      v-for="option in options"
      :key="option.value"
      :class="{ selected: value === option.value, [option.class]: option.class }"
      @click="onChange(option.value)"
    >
      <img v-if="option.iconSrc" :src="option.iconSrc" :alt="option.label" />
      {{ option.label }}
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    // Array of objects with label and value properties
    // Example: [{ label: 'Absolute', value: 'absolute' }, { label: 'Relative', value: 'relative' }]
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },

  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
  },
}
</script>
